/**
 * Styled Components - Created by david on 07/02/18.
 */
import styled from 'styled-components'
import { WHITE } from '../../theme/colors'

type ThemeProps = {
  darkMode?: boolean
  secondary?: boolean
}
import icon from 'antd/lib/icon'

export const Container = styled.div`
  position: relative;
  padding-inline: 72px;
  display: flex;
  flex-flow: column;
  align-items: center;
  background-color: var(--neutral-darkest);
`

export const Row = styled.div`
  display: flex;
  padding-block: 10px;
  max-height: 36px;
  max-width: 1296px;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${({ darkMode }: ThemeProps) => darkMode ? 'var(--neutral-darkest)' : 'unset'};
  .ant-menu {
    background: none !important;
  }
  @media (max-width: 767px) {
    justify-content: flex-end;
  }
`

export const CustomWorxLogo = styled.img`
  width: 97px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
  cursor: pointer;
  @media (max-width: 767px) {
    display: none;
  }
`

export const TopRow = styled.div`
  display: flex;
  gap: 38px;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  .ant-badge-count {
    background: #E11D1D;
    transform: unset;
    font-size: 10px;
    box-shadow: unset;
    left: 70%;
    top: -2px;
    height: 16px;
    line-height: 14px;
    font-family: var(--font-barlow);
    width: fit-content;
  }
`

export const MyOrders = styled.div`
  font-size: 12px;
  font-family: var(--font-barlow);
  letter-spacing: 1.12px;
  border-left: var(--border-regular) solid var(--neutral-secondary);
  padding-block: 4px;
  padding-inline: 16px 0;
  margin-left: 16px;
  display: flex;
  align-items: center;
  color: ${({ darkMode }: ThemeProps) => (darkMode ? WHITE : '#bb5555')};
  &:hover {
    cursor: pointer;
  }
`

export const Separator = styled.div`
  display: flex;
  align-items: center;
`

export const ShoppingIcon = styled(icon)`
  font-size: 12px;
  margin-right: 8px;
  color: ${({ darkMode }: ThemeProps) => (darkMode ? WHITE : '#bb5555')};
`

export const IconStyled = styled(icon)`
  margin-right: 14px;
  padding-left: 8px;
  font-size: 15px;
`
export const TopTextTitle = styled.div`
  color: ${({ darkMode }: ThemeProps) => (darkMode ? 'var(--neutral-white)' : '#bb5555')};
  cursor: pointer;
  font-family: var(--font-barlow);
  font-size: 12px;
  letter-spacing: 1.12px;
  border-left: var(--border-regular) solid var(--neutral-secondary);
  padding-left: 16px;
  margin-left: 0;
  @media (max-width: 1099px) {
    color: var(--neutral-darkest);
    border: 1px solid var(--neutral-darkest);
    padding: 8px;
    text-align: center;
  }
`

export const BottomRow = styled.div`
  display: flex;
  background: var(--neutral-darkest);
  padding-block: 12px;
  max-width: 1296px;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  #btnActions {
    display: flex;
    flex: 0 0 362px;
    gap: var(--spacing-16);
    width: 362px;
  }
`

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #dcdcdc;
`

export const LogoIcon = styled.img`
  cursor: pointer;
  flex-shrink: 0;
  max-width: 90px;
  height: 28px;
  width: 90px;
  transition: opacity .25s;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 1200px) {
    max-width: 118px;
    width: 118px;
  }
`

export const CartIcon = styled.img`
  cursor: pointer;
`

export const SearchIcon = styled.img`
  cursor: pointer;
`

export const TeamStoresMenuContainer = styled.div`
  display: flex;
  text-align: left;
`

export const TeamStoresMenuTitle = styled.div`
  color: #5f6062;
  font-size: 18px;
  line-height: 25px;
  border-bottom: 4px solid #e61737;
  padding: 21px 0;
  &:hover {
    cursor: pointer;
  }
`

export const notificationStyles = { cursor: 'pointer' }


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MenuBar/styledComponents.tsx